var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.000000,-1.000000) translate(0,-28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.000000 3.121320 L 20.091883 22.213204 L 22.213203 20.091883 L 3.121320 1.000000 Z",
    transform: "scale(1.000000,1.000000) translate(2.393398,2.393398)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.121320 22.213204 L 22.213203 3.121320 L 20.091883 1.000000 L 1.000000 20.091883 Z",
    transform: "scale(1.000000,1.000000) translate(2.393398,2.393398)",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerclose);
export default __webpack_public_path__ + "static/media/hamburgerclose.350bf72b7bbf5e824ec2b38be069b700.svg";
export { ForwardRef as ReactComponent };